export default {
  primaryColor: '#ffffff',
  secondaryColor: '#999999',
  accentColor: '#F3F3F3',

  backgroundPrimaryColor: '#424242',
  backgroundDefaultColor: '#303030',
};
